/**
 * IMPORTS
 */

import {
  takeEvery,
  put,
} from 'redux-saga/effects';

import {
  playSound,
  stopSound,
} from '../actions/sound-actions';

/**
 * CORE
 */

function* onTriggerSuccess() {
  yield put(stopSound('countdown-short'));
  yield put(stopSound('countdown-long'));
  yield put(playSound('trigger'));
}

function* onTriggerFailure() {
  yield put(stopSound('countdown-short'));
  yield put(stopSound('countdown-long'));
}

export default [
  takeEvery('TRIGGER_SESSION_SUCCESS', onTriggerSuccess),
  takeEvery('TRIGGER_SESSION_FAILURE', onTriggerFailure),
];
